
import styles from './index.module.scss';
import { useContext } from 'react';
import FieldsContext from '../../../contexts/Fields';
import AuthContext from '../../../contexts/Auth';
import RcmpCardUsers from '../CardUsers';
import { fnFormatDate, fnFormatDateFromUTC } from '../../../utils/date';
import { Typography } from '@stardust-ds/react';
import intl from 'react-intl-universal';
import { CSS } from '@dnd-kit/utilities';

import { forwardRef } from 'react';
import { useSortable } from '@dnd-kit/sortable';

const RcmpKanbanCard = forwardRef((props, ref) => {
    const { oData, aFieldsName, nId, setOCurrentDrag, oCurrentDrag, bIsCardDragging = false, onClick, oCollumn, bCanChange } = props;
    const { aAllFields } = useContext(FieldsContext);
    const { oUser } = useContext(AuthContext);
    const cUserTimezone = oUser?.data?.user_ctimezone
    const aFields = aFieldsName?.map(fieldName => {
        const filteredFields = aAllFields.filter(field => {
            if (field.opfd_nid === fieldName.opfd_nid || field.opfd_nid === fieldName.ombf_opfd_nid) {
                return {
                    fieldName: field.opfd_cname,
                    fieldId: field.opfd_nid,
                    fieldValue: "",
                    position: fieldName.position ?? null
                };
            } else return null;
        });
        return filteredFields.length > 0 ? filteredFields[0] : null;
    }).filter(field => field !== null);

    function fnCompareDate(date) {
        if (!date) return false
        try {
            const nTodayTime = new Date(
                fnFormatDate(new Date(), "YYYY-MM-DD HH:mm", false, cUserTimezone),
            ).getTime()
            const nDateTime = new Date(
                fnFormatDate(date, "YYYY-MM-DD HH:mm", true, cUserTimezone),
            ).getTime()
            return nDateTime <= nTodayTime ? true : false
        } catch (e) {
            console.log(e)
            return false
        }
    }

    function fnFormatDataField(data) {
        switch (data.opfd_ctype) {
            case "DATE": {
                return <Typography type='l2' color={fnCompareDate(data.opfv_cvalue) && data.opfd_cslug == "prazo"
                    ? "#FF3541"
                    : ""}>
                    {fnFormatDateFromUTC(data.opfv_cvalue, "DD/MM/YYYY HH:mm", oUser.data.user_ctimezone) || `-`}
                </Typography>
            }
            case "PEOPLES":
                return <RcmpCardUsers aUsers={data.opfv_cvalue} bSmall={true} /> || `-`;
            case "SELECTION":
                if (data.opfd_cslug === "status") {
                    return <Typography color={"#415364"} type="p3">{data?.selected_option?.opfs_coption_name === "Pending" ? intl.get("ActivityStatus.pending") : intl.get("ActivityStatus.done")}</Typography>;
                } else {
                    return <Typography color={data?.selected_option?.opfs_coption_color} type="p3">{data?.selected_option?.opfs_coption_name || `-`}</Typography>;
                }
            case "NUMBER":
            case "CALC":
            case "RANGE": {
                const cPrefix = data.field?.opfd_cprefix
                const cSufix = data.field?.opfd_csuffix

                if (cPrefix || cSufix) {
                    return <Typography type='l2' color={'#415364'}>{`${cPrefix ? cPrefix : ""} ${data.opfv_cvalue || ""} ${cSufix ? cSufix : ""}` || `-`}</Typography>;
                }
                return <Typography type='l2' color={'#415364'}>{data.opfv_cvalue || `-`}</Typography>;
            }
            default:
                return data.opfv_cvalue;
        }
    }

    const oDataRender = aFields?.map((field) => {
        const value = oData?.values?.find((val) => val.opfv_opfd_nid === field.opfd_nid) || {};
        return {
            ...value,
            ...field,
        };
    });
    const {
        setNodeRef,
        transform,
        listeners,
        attributes,
        isDragging
    } = useSortable({
        id: oData?.id, data: {
            type: "Card"
        },
        disabled: !bCanChange
    });

    const style = {
        transform: CSS.Transform.toString(transform)
    };

    function fnHandleOnClick(e, oItem) {
        e.preventDefault()
        e.stopPropagation()
        onClick(oItem, oCollumn)
    }
    if (isDragging) {
        if (oCurrentDrag === null) {
            setOCurrentDrag(prev => (props));

        }
        return (
            <div ref={setNodeRef} style={style} {...attributes} className={styles.cardContainerDragging} onClick={(e) => fnHandleOnClick(e, oData)} >
                {
                    oDataRender?.map((field, index) => {
                        const formatedValue = fnFormatDataField(field);
                        return (
                            <div key={index} className={styles.cardDragging}>
                                <Typography type='l3' color={'#415364'}>{field.opfd_cname}</Typography>
                                <Typography type='p1' color={'#415364'}>{formatedValue || `-`}</Typography>
                            </div>
                        );
                    })
                }
            </div>
        );
    }

    return (
        <div onClick={(e) => fnHandleOnClick(e, oData)} style={style} ref={setNodeRef} {...attributes} {...listeners} className={styles.cardContainer}  >
            {
                oDataRender?.map((field, index) => {
                    const formatedValue = fnFormatDataField(field);
                    return (
                        <div key={index} className={styles.card}>
                            <Typography type='l3' color={'#415364'}>{field.opfd_cname}</Typography>
                            <Typography type='p1' color={'#415364'}>{formatedValue || `-`}</Typography>
                        </div>
                    );
                })
            }
        </div>
    );

});

export default RcmpKanbanCard;